export const FORM_ENDPOINT = import.meta.env.VITE_FORM_ENDPOINT || '';
